import { Component } from 'react'

export default class SupplierBilling extends Component {
	render() {
		return <div className="page-content">Supplier Billing</div>
	}
}
